import { createValidator, ErrorObject, required } from 'util/validation'

import { isStatusValid } from '../../validator-consultaSeguimento'
import { ConsultaSeguimentoPergunta03Model } from './model-consultaSeguimentoPergunta03'
import { hasPergunta03ExemplosAnySim, isPergunta03ExemplosAllNao } from './utils-consultaSeguimentoPergunta03'

export const validatorConsultaSeguimentoPergunta03 = createValidator<ConsultaSeguimentoPergunta03Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_03_HEADER: required,
  },
  (values: ConsultaSeguimentoPergunta03Model, errors: ErrorObject<ConsultaSeguimentoPergunta03Model>) => {
    if (!hasPergunta03ExemplosAnySim(values) && !isPergunta03ExemplosAllNao(values)) {
      errors.PERGUNTA_03_EXEMPLOS = 'Deve responder sim para algum ou não para todos'
    }
    return errors
  }
)
